import { TechFeature } from '../types/content';

export const technicalFeatures: TechFeature[] = [
  {
    title: 'Customer Energy Analysis Portal',
    description:
      'Business lead for deployment of the electric customer portal enabling load forecasting and rate analysis.'
  },
  {
    title: 'Enterprise Ideation Platform',
    description:
      'Built and managed a crowd-sourced ideation system generating 350+ viable business ideas in Year 1.'
  },
  {
    title: 'Grid Monitoring Tech',
    description: 'Deployed grid-monitoring technologies recognized by the Nuclear Energy Institute.'
  },
  {
    title: 'Agile & Product Management',
    description: 'Deep experience as an Agile Scrum Master and Product Owner across business teams.'
  }
];
